module.exports = __webpack_public_path__ + "static/img/nophoto.6b25cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimages/nophoto.png
// module id = Yyvg
// module chunks = 34